import React from 'react';
import { Dropdown, Space, Avatar, Button, Modal, Form, Input, message } from 'antd';
import { UserOutlined, LogoutOutlined, KeyOutlined } from '@ant-design/icons';
import { authService } from '../../services/authService';

const UserInfo = ({ user, onLogout }) => {
  const [form] = Form.useForm();

  const handlePasswordChange = () => {
    form.resetFields();
    
    Modal.confirm({
      title: '修改密码',
      content: (
        <Form form={form} layout="vertical">
          <Form.Item
            name="oldPassword"
            label="当前密码"
            rules={[{ required: true, message: '请输入当前密码' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="新密码"
            rules={[{ required: true, message: '请输入新密码' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="确认新密码"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: '请确认新密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      ),
      onOk: async () => {
        try {
          const values = await form.validateFields();
          await authService.updatePassword(values.oldPassword, values.newPassword);
          message.success('密码修改成功');
          form.resetFields();
        } catch (error) {
          message.error('密码修改失败: ' + error.message);
        }
      },
      onCancel() {
        form.resetFields();
      },
    });
  };

  const items = [
    {
      key: 'userInfo',
      label: (
        <div style={{ padding: '8px 0' }}>
          <div><strong>用户名：</strong>{user.get('username')}</div>
        </div>
      ),
    },
    {
      key: 'changePassword',
      label: (
        <Button type="link" icon={<KeyOutlined />} onClick={handlePasswordChange}>
          修改密码
        </Button>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: (
        <Button type="link" danger icon={<LogoutOutlined />} onClick={onLogout}>
          退出登录
        </Button>
      ),
    },
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Space style={{ cursor: 'pointer', color: '#fff' }}>
        <Avatar icon={<UserOutlined />} />
        {user.get('username')}
      </Space>
    </Dropdown>
  );
};

export default UserInfo; 